import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import React, { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";

const UserRegpeackhour = () => {
  const [data, setData] = useState([]);
  const [startTime, setStartTime] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endTime, setEndTime] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(false);

  const [totalValues, setTotalValues] = useState({
    totalRegistrations: 0,
    maleCount: 0,
    femaleCount: 0,
    OtherCount: 0,
    appcount: 0,
    webcount: 0,
  });

  const getdata = async () => {
    try {
      setLoading(true);
      const postData = { CreatedFrom: startTime, CreatedTo: endTime };
      const res = await AddUpdate("User/Users_Peakhour", postData);
      const resdata = JSON.parse(res?.data?.data);
      const finaldata = resdata?.Table || [];
      setData(finaldata);

      let totalRegistrations = 0;
      let maleCount = 0;
      let femaleCount = 0;
      let otherCount = 0;
      let appcount = 0;
      let webcount = 0;

      finaldata.forEach((item) => {
        totalRegistrations += Number(item.TotalRegistrations || 0);
        maleCount += Number(item.MaleCount || 0);
        femaleCount += Number(item.FemaleCount || 0);
        otherCount += Number(item.OtherCount || 0);
        appcount += Number(item.AppCount || 0);
        webcount += Number(item.webCount || 0);
      });

      setTotalValues({
        totalRegistrations,
        maleCount,
        femaleCount,
        OtherCount: otherCount,
        appcount,
        webcount,
      });
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    getdata();
  };

  useEffect(() => {
    getdata();
  }, []);

  const transformData = () => {
    if (!data.length) return [];

    const rows = [
      { label: "Total Registrations" },
      { label: "Male Count" },
      { label: "Female Count" },
      { label: "Other Count" },
      { label: "App Count" },
      { label: "web Count" },
    ];

    data.forEach((item) => {
      const time = item.TimeRange || "-";
      rows[0][time] = item.TotalRegistrations ?? "-";
      rows[1][time] = item.MaleCount ?? "-";
      rows[2][time] = item.FemaleCount ?? "-";
      rows[3][time] = item.OtherCount ?? "-";
      rows[4][time] = item.AppCount ?? "-";
      rows[5][time] = item.webCount ?? "-";
    });

    return rows;
  };

  const transformedData = transformData();

  const [showModal, setShowModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [modalParams, setModalParams] = useState({});

  const mediumFromLabel = (label) => {
    switch ((label || "").toLowerCase()) {
      case "total registrations":
        return "TotalRegistrations";
      case "male count":
        return "MaleCount";
      case "female count":
        return "FemaleCount";
      case "other count":
        return "OtherCount";
      case "app count":
        return "AppCount";
      case "web count":
        return "WebCount";
      default:
        return "";
    }
  };

  const parseSelectedHour = (timeRange) => {
    if (!timeRange) return null;
   
    const parts = timeRange.split("-");
    if (!parts.length) return null;
    const start = parts[0].trim();
    const m = start.match(/(\d{1,2})\s*(am|pm)/i);
    if (!m) return null;
    let hour = Number(m[1]) || 0;
    const ampm = (m[2] || "").toLowerCase();
    
    let hour24 = hour % 12;
    if (ampm === "pm") hour24 = hour24 + 12;
  
    const index = hour24 + 1;
    return index; // 1..24
  };

  const handleCellClick = async (timeRange, label) => {
    try {
      const selectedHour = parseSelectedHour(timeRange);
      const medium = mediumFromLabel(label);
      setModalTitle(`${label} (${timeRange})`);
      setModalParams({ SelectedHour: selectedHour, Medium: medium });
      setShowModal(true);
      setModalLoading(true);

      const postData = { CreatedFrom: startTime, CreatedTo: endTime, SelectedHour: selectedHour, Medium: medium };
     
      const res = await AddUpdate("User/GetData_PeakHourUserList", postData);
      const resdata = JSON.parse(res?.data?.data || "{}");
      const rows = resdata?.Table || [];
      setModalData(rows);
    } catch (err) {
      console.error(err);
      setModalData([]);
    } finally {
      setModalLoading(false);
    }
  };

  const columns =
    data.length > 0
      ? [
          {
            name: "Category",
            selector: (row) => row.label,
            sortable: false,
            width: "200px",

            cell: (row) => (
              <div
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: 700,
                }}
              >
                {row.label}
              </div>
            ),

            style: {
              minWidth: "200px",
              maxWidth: "200px",
            },
          },
          ...data.map((item) => ({
            name: item.TimeRange || "-",
            selector: (row) => row[item.TimeRange || "-"],
            sortable: false,
            width: "120px",
            wrap: true,
            cell: (row) => (
              <div
                style={{ padding: "10px", textAlign: "center", cursor: "pointer" }}
                onClick={() => handleCellClick(item.TimeRange || "-", row.label)}
              >
                {row[item.TimeRange || "-"] ?? "-"}
              </div>
            ),
          })),
        ]
      : [{ name: "Category", selector: (row) => row.label }];

  const tableCustomStyles = {
    headCells: {
      style: {
        minHeight: "64px",
        maxHeight: "64px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        fontWeight: "700",
        fontSize: "14px",
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "#002b5b",
        color: "#fff",
      },
    },
    cells: {
      style: {
        minWidth: "100px",
        maxWidth: "140px",
        textAlign: "center",
        justifyContent: "center",
        padding: "6px 8px",
      },
    },
    rows: {
      style: {
        minHeight: "48px",
        fontSize: "14px",
      },
    },
  };

  return (
    <>
      <style>{`
        /* Wrapper to allow horizontal scrolling */
        .rdt_table_wrapper_custom {
          overflow-x: auto;
          position: relative;
        }

        /* Ensure the header row itself stays on top when fixedHeader is used */
        .rdt_TableHead {
          /* no change here; fixedHeader prop on DataTable will make header sticky top */
        }

        /* TARGET: first header cell (the Category header)
           .rdt_TableHeadRow .rdt_TableCol is the usual structure; we target the first child */
        .rdt_TableHeadRow .rdt_TableCol:first-child {
          position: sticky !important;
          left: 0 !important;
          top: 0 !important; /* stick to top (works with fixedHeader) */
          z-index: 60 !important; /* higher than body cells and other headers */
          background: #002b5b !important;
          color: #fff !important;
          border-right: 1px solid #ddd !important;
        }

        /* first header inner content alignment */
        .rdt_TableHeadRow .rdt_TableCol:first-child > div {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;
        }

        /* TARGET: first column body cells */
        .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {
          position: sticky !important;
          left: 0 !important;
          z-index: 40 !important; /* lower than header so header overlaps if necessary */
          background: #ffffff !important; /* ensure opaque bg so scrolled columns don't show through */
          border-right: 1px solid #ddd !important;
        }

        /* Make sure when header is sticky, it is above the table controls if any */
        .rdt_TableHeadRow {
          z-index: 55;
        }

        /* If DataTable renders slightly different class names in your version,
           include a fallback more generic selector: */
        .rdt_Table .rdt_TableHead .rdt_TableCol:first-child,
        .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {
          /* keep same styles as above as fallback */
        }

        /* small tweak: keep table layout to auto so widths behave as we set them */
        .rdt_Table {
          table-layout: auto;
        }
      `}</style>

      <div className="form-group main_card p-3">
        <h2 style={{ color: "#f7931e", fontWeight: 700 }}>
          User Registration Peak Hour
        </h2>

        <div className="row mt-3 align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <label className="form-label">Start Date</label>
            <input
              type="date"
              className="form-control"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <label className="form-label">End Date</label>
            <input
              type="date"
              className="form-control"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>

          <div className="col-md-3 col-sm-12 mb-3">
            <button className="btn btn-primary w-10" onClick={handleSearch}>
              Search
            </button>
          </div>
        </div>
      </div>

     <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    backgroundColor: "#f8f9fa",
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "15px 20px",
    marginBottom: "20px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  }}
>
  <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
    <h4 style={{ margin: 0, color: "#002b5c" }}>
      {totalValues?.totalRegistrations || 0}
    </h4>
    <span style={{ color: "#555", fontWeight: "500" }}>Total Registrations</span>
  </div>

  <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
    <h4 style={{ margin: 0, color: "#28a745" }}>
      {totalValues?.maleCount || 0}
    </h4>
    <span style={{ color: "#555", fontWeight: "500" }}>Male Count</span>
  </div>

  <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
    <h4 style={{ margin: 0, color: "#d63384" }}>
      {totalValues?.femaleCount || 0}
    </h4>
    <span style={{ color: "#555", fontWeight: "500" }}>Female Count</span>
  </div>

  <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
    <h4 style={{ margin: 0, color: "#d63384" }}>
      {totalValues?.OtherCount || 0}
    </h4>
    <span style={{ color: "#555", fontWeight: "500" }}>Other Count</span>
  </div>


  <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
    <h4 style={{ margin: 0, color: "#0d6efd" }}>
      {totalValues?.appcount || 0}
    </h4>
    <span style={{ color: "#555", fontWeight: "500" }}>App Count</span>
  </div>

  <div style={{ textAlign: "center", flex: "1", minWidth: "150px" }}>
    <h4 style={{ margin: 0, color: "#ffc107" }}>
      {totalValues?.webcount || 0}
    </h4>
    <span style={{ color: "#555", fontWeight: "500" }}>Web Count</span>
  </div>
</div>

     
      <div
        className="col-12 mt-2 main_card rdt_table_wrapper_custom"
        style={{ padding: 0 }}
      >
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={transformedData}
            columns={columns}
            customStyles={customStyles}
            fixedHeader
            fixedHeaderScrollHeight="400px"
            persistTableHead
            noDataComponent={"There are no data to display"}
            responsive
          />
        )}
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle || "Details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto',fontWeight:"bold" }}>
          {modalLoading ? (
            <div>Loading...</div>
          ) : modalData && modalData.length ? (
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    {Object.keys(modalData[0]).map((k) => (
                      <th key={k}>{k}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {modalData.map((r, idx) => (
                    <tr key={idx}>
                      {Object.keys(modalData[0]).map((k) => (
                        <td key={k}>{r[k]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div>No records found</div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserRegpeackhour;
